import type { MediaGrid, MediaGridType } from "../types";

export const DEFAULT_MEDIA_GRID: Readonly<MediaGrid> = {
  type: "square",
  cellsAcross: 20,
  color: "#f4e8c4",
  opacity: 0.42,
};

const clamp = (value: number, minimum: number, maximum: number) => Math.min(maximum, Math.max(minimum, value));

export function createMediaGrid(type: MediaGridType): MediaGrid {
  return { ...DEFAULT_MEDIA_GRID, type };
}

/**
 * Scene archives may come from an older version of TBLTOP or from another
 * machine. Keep the renderer safe and deterministic when a saved grid is
 * incomplete or malformed instead of allowing it to affect presentation.
 */
export function normalizeMediaGrid(value: unknown): MediaGrid | undefined {
  if (!value || typeof value !== "object" || Array.isArray(value)) return undefined;
  const candidate = value as Partial<MediaGrid>;
  if (candidate.type !== "square" && candidate.type !== "honeycomb") return undefined;
  const cellsAcross = Number(candidate.cellsAcross);
  const opacity = Number(candidate.opacity);
  const color = typeof candidate.color === "string" && /^#[0-9a-f]{6}$/i.test(candidate.color)
    ? candidate.color.toLowerCase()
    : DEFAULT_MEDIA_GRID.color;
  return {
    type: candidate.type,
    cellsAcross: Number.isFinite(cellsAcross) ? Math.round(clamp(cellsAcross, 4, 120)) : DEFAULT_MEDIA_GRID.cellsAcross,
    color,
    opacity: Number.isFinite(opacity) ? clamp(opacity, 0.08, 0.9) : DEFAULT_MEDIA_GRID.opacity,
  };
}
